import { render } from "./ApiKeyPairsTab.vue?vue&type=template&id=0f14c22d&scoped=true"
import script from "./ApiKeyPairsTab.vue?vue&type=script&lang=js"
export * from "./ApiKeyPairsTab.vue?vue&type=script&lang=js"

import "./ApiKeyPairsTab.vue?vue&type=style&index=0&id=0f14c22d&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f14c22d"]])

export default __exports__